import React, { useState } from 'react';
import PortabilitySaleFilter from './PortabilitySaleFilter';
import PortabilitySaleReport from './PortabilitySaleReport';

function PortabilitySale() {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = (m, y) => {
        setMonth(m);
        setYear(y);
        setIsSubmitted(true);
    };

    return (
        <div>
            <PortabilitySaleFilter onSubmit={handleSubmit} />

            <PortabilitySaleReport month={month} year={year} isSubmitted={isSubmitted} />
        </div>
    );
}

export default PortabilitySale;